import {Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ElementRef, HostListener, SimpleChanges} from '@angular/core';


@Component({
	selector: 'component-filter',
	templateUrl: './component.filter.html',
	styleUrls: ['./component.filter.css']
})

export class ComponentFilter implements OnInit, AfterViewInit {
  @Input() condition: string;
  @Input() selectedStatusIndex: number;
  @Input() selectedCourseIndex: number;
  @Input() camp: any;
  @Input() conditionFilter: any;
  @Output() onReturn = new EventEmitter<any>(); //关闭筛选
  @Output() sendCondition = new EventEmitter<any>(); //筛选


  subCondition: any = [];
  selectedConditionIndex: number = 0;

  constructor() {}


  ngOnChanges(changes: SimpleChanges){

  }

  ngOnInit() {
    setTimeout(()=>{
      this.camp.unshift({id:0,name:'全部课程'});
      this.subCondition = {
        '课程': this.camp,
        '状态': ['全部状态','未开放','未提交','已提交','已点评']
      }[this.condition] || [];

      this.selectedConditionIndex = {
        '课程': this.selectedCourseIndex,
        '状态': this.selectedStatusIndex
      }[this.condition] || 0;
    },0);
  }

  ngAfterViewInit() {
    setTimeout(()=>{
      $('.filter-condition').eq(this.selectedConditionIndex).addClass('active');
    },10);
  }


  //进行筛选
  doFilter(index:number,type:string):void{
    let condition = type === '状态' ? {0:0, 1:1, 2:2, 3:3, 4:4}[index]||0 : this.camp[index]['id'];
    this.conditionFilter['type'] = type;
    if(type === '状态'){
      this.conditionFilter['statusIndex'] = index;
      this.conditionFilter['status'] = condition;
      this.sendCondition.emit( this.conditionFilter);
    }else if(type === '课程'){
      this.conditionFilter['courseIndex'] = index;
      this.conditionFilter['id'] = condition;
      this.sendCondition.emit( this.conditionFilter);
    }
    this.closeFilter();
  }

  //关闭筛选
  closeFilter():void{
    this.camp.shift();
    this.onReturn.emit();
  }

}



// WEBPACK FOOTER //
// ./src/component/filter/component.filter.ts